import React, { Component, useEffect, useState } from 'react';
import Datas from '../data/about-us/about-us.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/aboutUs.js";
import axios from 'axios';

const AboutUs = () => {
    // constructor() {
    //     super()
    //     this.state = {
    //         isOpen: false
    //     }
    //     this.openModal = this.openModal.bind(this)
    // }

    // openModal() {
    //     this.setState({ isOpen: true })
    // }
    const [aboutUs, setAboutUs] = useState([]);
    useEffect(() => {
        const aboutUs = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/abouts/find-all`).then(res => {
                setAboutUs(res.data)
            }).catch(err => console.error(err))
        }
        aboutUs();
    },[])

    return (
        <Styles>
            {/* About Us */}
            <section className="about-us">
                <Container>
                    <Row>
                    {
                        aboutUs !== null && aboutUs.length > 0 ? aboutUs.map((data, i) => (
                            <React.Fragment key={i} >
                                <Col md="6" style={{display: "flex", alignItems: "center"}} >
                                    <div className="about-image">
                                        
                                        <img src={process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) 
                                        + `${data.aboutImg.substring(data.aboutImg.indexOf("/uploads"))}`} alt="AboutImg"
 className="main-img" />
  
                                        {/* <img src={process.env.PUBLIC_URL + `/assets/images/${Datas.mainImage}`} className="main-img" alt="" /> */}
                                        {/* <img src={process.env.PUBLIC_URL + "/assets/images/pattern.png"} className="pattern-img" alt="" /> */}
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="about-content">
                                        <h1 className="about-title">About Us</h1>
                                        <p className="about-para" dangerouslySetInnerHTML={{ __html: data.aboutDesc}}></p>
                                        <h4 className="about-tag-line">{data.aboutTagLine}</h4>
                                    </div>
                                </Col>
                            </React.Fragment>
                        )): "No about content"
                    }
                        
                    </Row>
                </Container>
            </section>
        </Styles>
    )
    
}

export default AboutUs
